import TableView from './components/TableView'

// Sync route definition
export default {
  path : 'table',
  component : TableView
}



// WEBPACK FOOTER //
// ./src/routes/Table/index.js